import "./Access.css"
export default function MainPic(props) {
    return props.ModuleDetails.map((md, index) => {

        return <div
            className="containplatform1"
            style={{ backgroundColor: props.BackgroundColor }}
            key={index}
        >
            <img
                alt={props ? md.ImageAlt : ""}
                src={md ? md.ImageURL : ""}
            />

        </div>
    })
}